import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useRecommendedVideos from '../hooks/useRecommendedVideos';
import { useVideoDetailsFromParams } from '../hooks/useVideoDetailsFromParams';
import { generatePlayerPageViewUrl } from '../../../utils/generatePlayerPageViewUrl';
import VideoCardV2 from '../../../component/VideoCardV2';
import useViewMoreModal from '../hooks/useViewMoreModal';
import AddToPlayListModal from '../../../component/playlist/personal-playlist/AddToPlayListModal';
import useResize from '../hooks/useResize';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import { getSignupRoute } from '../../../constants/featureFlags';
import { sendClickEvent } from '@/service/algolia';


const RecommendedVideos = ({ selectedVideo, isPromo = false, skip = false, skipClasses = false, recommendedTextOverride = '' }) => {
	const { videos, recommendedText } = useRecommendedVideos({ skip, skipClasses });
	const { typeOfContentView, playlistId } = useVideoDetailsFromParams();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const visibleCount = 5;
	const [videoData, setVideoData] = useState(null);
	const [modal, setModal] = useState(false);
	const deviceType = useResize();

	

	const scrollRef = useRef(null);
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(true);

	const { ViewMoreButton, Modal } = useViewMoreModal(visibleCount);

	const openSignup = () => {
		const params = new URLSearchParams();
		const promoToken = searchParams.get('promoToken') || '';
		if (promoToken) {
			params.set('promo', 'advanced-jumps');
			params.set('promoToken', promoToken);
		}
		const signupRoute = getSignupRoute();
		const signupUrl = params.toString() ? `${signupRoute}?${params.toString()}` : signupRoute;
		window.open(signupUrl, '_blank', 'noopener,noreferrer');
	};

	const redirectToVideo = videoId => {
		if (isPromo) {
			openSignup();
			return;
		}
		if (videoId) {
			sendClickEvent({
				objectID: String(videoId),
				userToken: searchParams.get('userId') || 'anonymous'
			});
		}
		const url = generatePlayerPageViewUrl(videoId, typeOfContentView, playlistId);
		navigate(url);
	};
	const checkScroll = () => {
		const el = scrollRef.current;
		if (!el) return;
		setCanScrollLeft(el.scrollLeft > 0);
		setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
	};

	useEffect(() => {
		checkScroll();
	}, [videos]);

	const scroll = (direction) => {
		const el = scrollRef.current;
		if (!el) return;
		const scrollAmount = 300;
		el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
	};

	if (!videos.length) return null;

	return (
		<div className="c-video-set-list c-mobile-video_slider">
			<div className="c-video-set-list-h3">
				<h3 className={isPromo ? 'promo-recommended-heading' : undefined}>
					{recommendedTextOverride || recommendedText}
					{isPromo && <NorthEastIcon fontSize="small" />}
				</h3>
				<ViewMoreButton data={videos} />
			</div>


			<div className="slide_arrow_container">
				{canScrollLeft && (
					<div className="left_arrow" onClick={() => scroll('left')}>
						<ArrowBackIosIcon style={{ fontSize: '30px', color: '#097dac' }} />
					</div>
				)}
				{canScrollLeft && <div className="fade-left" />}
				<div className="c-video-set-listbox" ref={scrollRef} onScroll={checkScroll}>
					{videos
						.slice(0, videos.length > visibleCount && deviceType !== 'mobile' ? visibleCount : videos.length)
						.map((video, index) => {
							const hasComingSoonTag = video.tagsDetails?.some(tag => tag.name === 'coming soon');

							return (
								<div
									key={video.v_id || index}
									onClick={() => {
										if (!hasComingSoonTag) redirectToVideo(video._id);
									}}
									style={hasComingSoonTag ? { opacity: 0.7, cursor: 'default' } : { cursor: 'pointer' }}
								>
									<VideoCardV2
										video={video}
										modal={modal}
										setModal={setModal}
										setVideoData={setVideoData}
										customStyles={{
											width: deviceType === 'mobile' ? '272px' : '352px',
											pointerEvents: 'auto' 
										}}
										titleStyles={{ fontSize: '14px' }}
									/>
								</div>
							);
						})}
				</div>



				{canScrollRight && (
					<div className="right_arrow" onClick={() => scroll('right')}>
						<ArrowForwardIosIcon style={{ fontSize: '30px', color: '#097dac' }} />
					</div>
				)}
				{canScrollRight && <div className="fade-right" />}
			</div>
			<Modal videos={videos} selectedVideo={selectedVideo} />
			<AddToPlayListModal modal={modal} setModal={setModal} activeObject={videoData} />
		</div>
	);
};

RecommendedVideos.propTypes = {
	selectedVideo: PropTypes.object.isRequired,
	isPromo: PropTypes.bool,
	skip: PropTypes.bool,
	skipClasses: PropTypes.bool,
	recommendedTextOverride: PropTypes.string
};

export default RecommendedVideos;
